<div [class]="containerClasses()">
    @if (label()) {
        <label [for]="inputId">
            {{ label() | translate }}
            @if (isRequired()) {
                <span class="text-danger" aria-label="required">*</span>
            }
        </label>
    }

    <div [ngClass]="{'custom-input-group': hasIcon()}">
        @if (isLeftIcon() && !flatpickrOptions().inline) {
            <span class="custom-input-group-text icon-left" (click)="openCalendar()">
                <i class="ti {{groupIcon()}}" aria-hidden="true"></i>
            </span>
        }

        <input type="text"
               mwlFlatpickr
               flatpickrPlaceholderSync
               #datepicker="mwlFlatpickr"
               [id]="inputId"
               [class]="inputClasses()"
               altInputClass="form-control"
               [placeholder]="placeholder()"
               [maxDate]="maxDate()"
               [minDate]="minDate()"
               [dateFormat]="flatpickrOptions().dateFormat"
               [options]="flatpickrOptions()"
               [convertModelValue]="false"
               [disabled]="isDisabled()"
               [attr.aria-describedby]="getAriaDescribedBy()"
               [(ngModel)]="currentValue"
               (ngModelChange)="onModelChange($event)"
               (focus)="onFocus()"
               [class.ng-invalid]="isInvalid"
               [class.ng-touched]="isTouched"
               [class.ng-dirty]="isDirty">

        @if (isRightIcon() && !flatpickrOptions().inline) {
            <span class="custom-input-group-text icon-right" (click)="openCalendar()">
                <i class="ti {{groupIcon()}}" aria-hidden="true"></i>
            </span>
        }
    </div>

    @if (showErrorDescription()) {
        @if (ngControl?.control) {
            <app-control-error
                    [control]="getControl()"
                    [customErrors]="customErrors()">
            </app-control-error>
        }
    }

    @if (hint()) {
        <div class="form-text" [id]="inputId + '_hint'">
            {{ hint() | translate }}
        </div>
    }
</div>
